import { useMarketplace } from 'hooks/useMarketplace';

export const useTimeZone = () => {
    const marketplace = useMarketplace();

    return marketplace.timeZone;
};
